module.exports = "/_next/static/images/Hero-92243e74bcd5be6812648578aa882310.webp";